"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFromHTMLString = exports.FormatBytes = void 0;
const FormatBytes = (bytes, decimals) => {
    // convert correct value to number
    if (typeof bytes === 'string') {
        const pattern = /^\d+$/;
        if (pattern.test(bytes)) {
            // string with numbers
            bytes = parseInt(bytes, 10);
        }
        else {
            // string with letters (can be converted value)
            return bytes;
        }
    }
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024, dec = decimals || 2, sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'], i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dec))} ${sizes[i]}`;
};
exports.FormatBytes = FormatBytes;
const TextFromHTMLString = (text) => {
    if (!text || typeof text !== 'string') {
        return text;
    }
    return text.replace(/<(?:.|\n)*?>/gm, '');
};
exports.TextFromHTMLString = TextFromHTMLString;
